<template>
  <div class="eg-tabs">
    <b-tabs
      v-bind="$attrs"
      class="eg-tabs__container d-flex flex-column overflow-auto"
      nav-class="eg-tabs__nav no-print"
      nav-item-class="eg-tabs__nav-item"
      v-on="$listeners"
    >
      <slot />
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "EgTabs",
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
.eg-tabs {
  width: 100%;

  &__container {
    width: 100%;
  }

  &__nav {
    border-bottom: 1px solid #e5ebf0;
    margin-bottom: 0;

    .eg-tabs__nav-item {
      margin-bottom: 0;

      .eg-tabs__nav-link {
        border: none;
        background: transparent;
        color: #6c757d;
        font-weight: 500;
        font-size: 14px;
        padding: 12px 16px;
        position: relative;
        transition: color 0.2s ease;

        &:hover {
          color: #673ab7;
          background: transparent;
          border: none;
        }

        &:focus {
          box-shadow: none;
          outline: none;
        }

        &--active {
          color: #673ab7;
          background: transparent;
          border: none;

          &::after {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 3px;
            background-color: #673ab7;
            border-radius: 2px 2px 0 0;
          }
        }
      }
    }
  }
}

// Override Bootstrap tabs styles
:deep(.eg-tabs__container) {
  .nav-tabs {
    padding: 0 1.5rem;
    border-bottom: 1px solid #e5ebf0;

    .nav-item {
      margin-bottom: 0;

      .nav-link {
        position: relative;
        border: none;
        background: transparent;
        padding: 8px 16px;

        color: var(--color-text-neutral-fade);
        text-align: center;
        text-overflow: ellipsis;

        font-family: var(--typography-font-family-text-primary);
        font-size: var(--typography-font-size-fs-300);
        font-style: normal;
        font-weight: var(--typography-font-weight-fw-500);
        line-height: 150%;

        &:hover {
          color: var(--color-text-primary-default);
          background: transparent;
          border: none;
        }

        &.active {
          color: var(--color-text-primary-default);
          background: transparent;
          border: none;

          &::after {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 3px;
            background-color: var(--color-stroke-primary-default);
            border-radius: 2px 2px 0 0;
          }
        }
      }
    }
  }

  .tab-content {
    overflow: auto;
  }
}
</style>
